import moment from 'moment'

export const formatArcAdvertiserForApi = (values) => {
  return {
    type: 'arc_advertisers',
    attributes: {
      name: values.name,
    },
  }
}

export const formatArcAdvertiserForForm = (advertiser) => {
  if (!advertiser) return {}
  return {
    id: advertiser.id,
    name: advertiser.attributes.name,
    contact_email: advertiser.attributes.contact_email,
  }
}

export const formatArcAdvertiserForTable = (advertiser) => {
  if (!advertiser) return {}
  return {
    key: advertiser.id,
    id: advertiser.id,
    name: advertiser.attributes.name,
    contact_email: advertiser.attributes.contact_email,
    created_at: moment(advertiser.attributes.created_at).format('YYYY-MM-DD HH:mm'),
    updated_at: moment(advertiser.attributes.updated_at).format('YYYY-MM-DD HH:mm'),
  }
}